import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpService } from '../shared/services/http.service';


@Injectable({
  providedIn: 'root'
})
export class Outcome {

  httpService=inject(HttpService);

  getoutcomes(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/outcomes/list`,data);
  }

  terminateOutcome(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/outcomes/terminate`,data);
  }

  updateOutcome(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/outcomes/update`,data);
  }

  detailOutcome(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/outcomes/detail`,data);
  }
  
  outcomeDropdownList(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/outcomes/list/dropdown`,data);
  }

  cloneQuarterlyOutcome(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/quarterly/outcomes/clone`,data);
  }

  tagQuarterlyOutcome(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/quarterly/outcomes/tag`,data);
  }

  listPrevQuarterlyOutcome(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/quarterly/outcomes`,data);
  }

  createMilestones(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/milestones/create`,data);
  }

  updateMilestones(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/milestones/update`,data);
  }

  terminateMilestones(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/milestones/terminate`,data);
  }

  addMilestonesDependencies(data: any, cat: number): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/milestones/add/dependencies`,data);
  }

  transformBacklog(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/backlogs/transform`,data);
  }

  historyBacklog(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/backlogs/history`,data);
  }

  createBacklog(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/backlogs/create`,data);
  }

  updateBacklog(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/backlogs/update`,data);
  }

  removeBacklog(data: any, cat: any): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/backlogs/remove`,data);
  }

}
